var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { FirebaseApp } from 'angularfire2';
import { Storage } from '@ionic/storage';
import { CommonProvider } from '../../providers/common/common';
var FirebaseMessagingProvider = /** @class */ (function () {
    function FirebaseMessagingProvider(platform, storage, app, comProv) {
        this.platform = platform;
        this.storage = storage;
        this.app = app;
        this.comProv = comProv;
        this.unsubscribeOnTokenRefresh = function () { };
    }
    FirebaseMessagingProvider.prototype.start = function () {
        var _this = this;
        if (this.comProv.isApp()) {
            return;
        }
        if (this.comProv.isIos()) {
            return;
        }
        if (!this.comProv.isPwaAccount()) {
            return;
        }
        if (this.comProv.isPc()) {
            return;
        }
        if (location.hash == '#/share' || location.hash == '#/privacy') {
            return;
        }
        try {
            this.messaging = this.app.messaging();
            navigator.serviceWorker.register('service-worker.js').then(function (registration) {
                _this.messaging.useServiceWorker(registration);
                //this.disableNotifications()
                _this.enableNotifications()
                    .catch(function (err) {
                    console.log('Unable to get permission to notify. ', err);
                });
            });
        }
        catch (e) {
            console.log(e);
        }
    };
    FirebaseMessagingProvider.prototype.enableNotifications = function () {
        var _this = this;
        console.log('Requesting permission');
        return this.messaging.requestPermission().then(function () {
            console.log('Permission granted');
            _this.setupOnTokenRefresh();
            return _this.updateToken();
        });
    };
    FirebaseMessagingProvider.prototype.disableNotifications = function () {
        this.unsubscribeOnTokenRefresh();
        this.unsubscribeOnTokenRefresh = function () { };
        return this.storage.set('fcm_token', '').then();
    };
    FirebaseMessagingProvider.prototype.updateToken = function () {
        var _this = this;
        return this.messaging.getToken().then(function (currentToken) {
            if (currentToken) {
                return _this.storage.set('fcm_token', currentToken);
            }
            else {
                console.log('No Instance ID token available. Request permission to generate one.');
            }
        });
    };
    FirebaseMessagingProvider.prototype.setupOnTokenRefresh = function () {
        var _this = this;
        this.unsubscribeOnTokenRefresh = this.messaging.onTokenRefresh(function () {
            console.log("Token refreshed");
            _this.storage.set('fcm_token', '').then(function () { _this.updateToken(); });
        });
    };
    FirebaseMessagingProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [Platform,
            Storage,
            FirebaseApp,
            CommonProvider])
    ], FirebaseMessagingProvider);
    return FirebaseMessagingProvider;
}());
export { FirebaseMessagingProvider };
//# sourceMappingURL=firebase-messaging.js.map


// WEBPACK FOOTER //
// ./src/providers/firebase-messaging/firebase-messaging.ts.pre-build-optimizer.js